var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("HKLModal", {
    ref: "modal",
    attrs: {
      hasCancelBtn: false,
      closable: true,
      title: _vm.$t(
        "termsAndConditions." +
          _vm.regionName +
          ".workPermit.hintForDisableSubApplyBtn"
      ),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }